import React, { Component } from 'react'
import g, { Span } from 'glamorous'
import Swiper from 'react-id-swiper'
import 'react-id-swiper/src/styles/css/swiper.css'

import TeamInDate from './team-in-date-fragm'
import CardViews from './card-views-fragm'

import moment from 'moment';
import 'moment-timezone-all';
import _ from 'lodash';
import 'moment/locale/es';

import './styles/index.scss'

import LazyLoad from 'react-lazyload';

import DFPAdsProvider from '@univision/fe-commons/dist/components/ads/dfp/DFPAdsProvider';
import DFPAd from '@univision/fe-commons/dist/components/ads/dfp/DFPAd';
import BKPIndicator from '@univision/fe-commons/dist/components/breakpoint/BreakPointIndicator';

import { pageData } from '../../config/advertising';

import adHelper from '@univision/fe-commons/dist/utils/ads/adHelper';
import AdSettings from '@univision/fe-commons/dist/utils/ads/adSettings.json';
import * as AdTypes from '@univision/fe-commons/dist/utils/ads/ad-types';


class DateView extends Component {

    getGroupedAndOrderedMatchsByDatetime() {
        const { matchs } = this.props.nodes.data.matchSchedule
        return _.chain(matchs)
                .groupBy((mt) => moment(parseInt(mt.datetimeUTC, 0)).startOf('day').format())
                .map((matchs, date) => {
                    return { matchs: matchs, date: date }
                })
                .sortBy('date')
                .value()
    }
    set_content_type()  
	{
		try {
			utag.content_type = "slideshow";
			utag.primary_tag = "Calendario Mundial Rusia 2018";
		}catch(errr){}
	}
	track_click($tag_name)
	{
		this.set_content_type();
		try {
			
			utag.link({ 
				event : 'engagement', 
				promo_type : 'other', 
				promo_loc : 'http://www.univision.com/calendario-y-horarios-del-mundial-de-rusia-2018', 
				promo_name : $tag_name
			});
		} catch (errr) { }
	}
    callDFPAd = (type, index) => {
        const adSettings = AdSettings[AdTypes[type]];
        const settings = adHelper.getSettings(adSettings);

        
        if(index == 7){
            return (
                <div style={{ "textAlign": "center" }}>
                  <BKPIndicator />
                  <g.Div className="container-advertising">
                    <DFPAdsProvider
                        env={pageData.env}
                        settings={pageData.data.adSettings}
                        requestParams={pageData.requestParams}
                        contentType={pageData.data.type}
                    >
                        <DFPAd {...settings}  />
                    </DFPAdsProvider>
                  </g.Div>
                </div>
              );
        }
        else {
            return (
                <div></div>
            );
        }
    };
    getOneMatchById(matchId) {
        const { matchs } = this.props.nodes.data.matchSchedule
        let rmatchs = matchs.filter(mt => mt.id === parseInt(matchId, 0))
        return rmatchs.length > 0 ? rmatchs[rmatchs.length - 1] : null
    }

    getOneStadiumById(stadiumId) {
        const { stadiums } = this.props.nodes.data.matchSchedule
        let rstadiums = stadiums.filter(st => st.id === stadiumId)
        return rstadiums.length > 0 ? rstadiums[rstadiums.length - 1] : null
    }

    getOneTeamByGroupIdAndPosition(groupId, positionId) {
        const { teams } = this.props.nodes.data.matchSchedule;
        let rteams = teams.filter(tm => tm.group.id === groupId && tm.group.position === positionId)
        return rteams.length > 0 ? rteams[rteams.length - 1] : 
        { 
            id: 9999, 
            flag: 'default.png', 
            isoalph3: groupId+positionId, 
            name: groupId+positionId,
            "player": {
                "name": "",
                "earnings": 0,
                "pic": "default.png"
            },
            "food": {
                "name": "",
                "calories": 0,
                "pic": "default.png"
            },
            "beverage": {
                "name": "",
                "alcoholProof": 0,
                "pic": "default.png"
            }
        }
    }

    formatUTCMatchDate(datetimeUTC, format) {
        return moment(parseInt(datetimeUTC, 0)).tz(moment.tz.guess()).format(format)
    }

    formatDate(date, format) {
        return moment(date).tz(moment.tz.guess()).format(format)
    }
	
	render() {
        const { groups, dates, defaults } = this.props.nodes.data.matchSchedule
        const currentMatch = this.getOneMatchById(this.props.currentMatchId)
        const currentLeftTeam = this.getOneTeamByGroupIdAndPosition(currentMatch.leftTeam.groupId, currentMatch.leftTeam.position)
        const currentRightTeam = this.getOneTeamByGroupIdAndPosition(currentMatch.rightTeam.groupId, currentMatch.rightTeam.position)
        const currentStadium = this.getOneStadiumById(currentMatch.stadiumId)
		return (
			<g.Div className="uvn-fifa2018-group-view uvn-fifa2018-date-view">
                <g.Ul>
                {
                    this.getGroupedAndOrderedMatchsByDatetime().map((mtg, mtgk) => {
                        return (<g.Li key={mtgk} id={`${mtgk}MTG`}  className="uvn-fifa2018-group-view-item">
                                    <g.Div className="dates">
                                        <g.Ul>
                                            <g.Li>
                                                <g.Ul className="list-dates">
                                                    <g.Li className="date-block-info">
                                                        <g.Div className="content-info-date">
                                                            <g.Div className="day-name" textTransform="uppercase">{this.formatDate(mtg.date, 'ddd')}</g.Div>
                                                            <g.Div className="day-number">{this.formatDate(mtg.date, 'DD')}</g.Div>
                                                            <g.Div className="rest-date">{this.formatDate(mtg.date, 'MM / YYYY')}</g.Div>
                                                            <g.H2 display="none">{this.formatDate(mtg.date, 'ddd DD/MM/YYYY HH:mm z')}</g.H2>
                                                        </g.Div>
                                                    </g.Li>
                                                    {
                                                        mtg.matchs.map((mt, mtk) => {
                                                            return (<g.Li
                                                                        key={mtk}
                                                                        cursor="pointer"
                                                                        className={mt.id === currentMatch.id ? 'selected' : ''}
                                                                        onClick={() => {
                                                                            this.track_click('CalendarioRusia2018Card'); 
                                                                            this.props.gotomatch(mt.id);
                                                                        }}>
                                                                <g.Div className="content-info-date">
                                                                    <g.Div className="date-string">{this.formatUTCMatchDate(mt.datetimeUTC, 'HH:mm z')}</g.Div>
                                                                    <g.H3 display="none">{this.getOneTeamByGroupIdAndPosition(mt.leftTeam.groupId, mt.leftTeam.position).name} VS {this.getOneTeamByGroupIdAndPosition(mt.rightTeam.groupId, mt.rightTeam.position).name}</g.H3>
                                                                    <TeamInDate
                                                                        className="team-left"                                                                                        
                                                                        team={this.getOneTeamByGroupIdAndPosition(mt.leftTeam.groupId, mt.leftTeam.position)} />
                                                                    <g.Div className="vs">VS</g.Div>
                                                                    <TeamInDate
                                                                        className="team-right"
                                                                        team={this.getOneTeamByGroupIdAndPosition(mt.rightTeam.groupId, mt.rightTeam.position)} />
                                                                </g.Div>
                                                            </g.Li>)
                                                        })
                                                    }
                                                </g.Ul>
                                            </g.Li>
                                        </g.Ul>
                                    </g.Div>
                                    {
                                        (currentMatch !== null && moment(parseInt(currentMatch.datetimeUTC, 0)).startOf('day').format() === mtg.date) &&
                                        <CardViews
                                            currentLeftTeam={currentLeftTeam}
                                            currentRightTeam={currentRightTeam}
                                            currentMatch={currentMatch}
                                            defaults={defaults}
                                            currentStadium={currentStadium}
                                            cardIndex={this.props.cardIndex}
                                            gotocard={this.props.gotocard}
                                            emphasysCard={this.props.emphasysCard} />
                                    }
                                    <LazyLoad > 
                                        {this.callDFPAd("TOP_AD", mtgk)}
                                    </LazyLoad>
                                </g.Li>)
                    })
                }
                </g.Ul>
			</g.Div>
		)
	}
}

export default DateView


// WEBPACK FOOTER //
// ./src/components/calendar/date-view.js